export const addTooltipField = (columnProperties: any[]) => {
    return columnProperties.map(json => {
        return {
            ...json,
            tooltipField: json.field,
            tooltipComponent: (props : any) => {
                return (
                    <div className="custom-tooltip-rdds">
                        <div>{props.value}</div>
                    </div>
                );
            }
        };
    });
}